var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M5 12.25h14a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1Z"
})));
export default SvgMinus;